import styled from 'styled-components'

export const Root = styled.section`
  color: white;
  font-family: sans-serif;
`
